import styled from "styled-components";

interface Props {
  backgroundColor?: string;
  height?: string;
  width?: string;
  // Spinner gradient color. Defaults to the brand purple; pass e.g. a gray to
  // match a neutral context.
  color?: string;
  // Size of the center hole (the ::before). Larger = thinner spinner ring.
  // Defaults to 60%.
  innerSize?: string;
}

const CircularLoader = styled.div<Props>`
  position: relative;
  width: ${({ width }) => width || "30px"};
  height: ${({ height }) => height || "30px"};
  border-radius: 10rem;
  border: 2px solid white;
  border-color: ${({ backgroundColor }) => backgroundColor || "white"};
  background: ${({ color }) =>
    color
      ? `linear-gradient(${color} 0%, ${color} 20%, transparent 100%)`
      : "linear-gradient(#b54ad1 0%, #b54ad1 20%, #f8edfb 100%)"};

  animation: animate 1s linear infinite;

  &::before {
    position: absolute;
    content: "";
    background: ${({ backgroundColor }) => backgroundColor || "white"};
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    width: ${({ innerSize }) => innerSize || "60%"};
    height: ${({ innerSize }) => innerSize || "60%"};
    border-radius: 10rem;
    border: 3px solid white;
    border-color: ${({ backgroundColor }) => backgroundColor || "white"};
  }

  @keyframes animate {
    from {
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }
`;

export default CircularLoader;
